/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { getFolder } from '../../../../actions/media_actions';
import { useSelector } from 'react-redux';
import Loading from '../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import GroupUserSvgIcon from '../../../../../assets/SvgIcons/GroupUserSvgIcon';
import { useParams } from 'react-router-dom';
import { LanguageContext } from '../../../../../libs/Context';
import ProfilePic from '../../../../../components/Common/ProfilePic';
import { Box } from '@mui/material';

const SharedInfo = (props:any) =>
{
	const { sharedSliderClose, data } = props;

	const userData = useSelector((state:any) => state.mysession.session);
	const [ shareData, setShareData ] = useState<any>({ rel: [], indivi: [] });
	const [ loading, setLoading ] = useState(false);
	const userId = useParams()?.userId;
	const { language } = useContext(LanguageContext);

	const SharedPeoples = async () =>
	{
		setLoading(true);
		const query: any = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role,
			id      : data?.folderId
		};

		if (userId)
		{
			query.userId = userId;
		}

		try
		{
			const res = await getFolder(query, 'shareTo');

			if (res?.status)
			{
				const relations:any = [];
				const individual:any = [];

				res?.data?.map((item:any) =>
				{
					if (item?.type === 'relation')
					{
						relations.push(item);
					}
					else
					{
						individual.push(item);
					}

					return setShareData({ rel: relations, indivi: individual });
				});
				setLoading(false);
			}
		}
		catch (err)
		{
			console.log(err);
			setLoading(false);
		}
	};

	useEffect(() =>
	{
		SharedPeoples();
	}, []);

	return (
		<>
			<div className='flexRow pdngSM alignCntr fxdRSliderHdr brdrBSM'>
				<div className='flexAutoRow alignCntr'>
					<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && sharedSliderClose(); }} className='imgAvatarSM pointer iconBlock' onClick={sharedSliderClose}>
						<ArrowBackIosNewOutlinedIcon color='primary'/>
					</button>
				</div>
				<div className='flexMinWidthRow justifyCntr'>
					<span className='titleHeading headingLG'>{language?.sharedInfo}</span>
				</div>
			</div>
			{loading && <Loading />}
			<div className='flexMinHeightCol pdngXS'>
				{!loading && shareData?.rel?.length > 0 &&
				<div className='flexRow pdngHXS mrgnTXS'>
					<span className='titleHeading headingMD capitalTxt'>{language?.relationTypeShare}</span>
				</div>
				}
				<div className='flexCol'>
					{!loading && shareData?.rel?.length > 0 && shareData?.rel.map((item:any) => (
						<div className='flexRow pdngXS' key={item?.name}>
							<div className='flexAutoRow alignCntr'>
								<div className='imgAvatarSM pointer brdrRadius50 baseSDBg iconBlock'>
									<GroupUserSvgIcon/>
								</div>
							</div>
							<div className='flexMinWidthRow pdngHSM alignCntr'>
								<span className='titleHeading capitalTxt'>{item?.name}</span>
							</div>
						</div>
					))}
				</div>
				{!loading && shareData?.indivi?.length > 0 &&
				<div className='flexRow pdngHXS mrgnTSM'>
					<span className='titleHeading headingMD capitalTxt'>{language?.individualShare}</span>
				</div>
				}
				<div className='flexCol'>
					{!loading && shareData?.indivi?.length > 0 && shareData?.indivi.map((item:any) => (

						<div className='flexRow pdngXS' key={item?.name}>
							<div className='flexAutoRow alignCntr'>
								<div className='imgAvatarSM pointer brdrRadius50'>
									{/* <LazyLoadImage
										src={item?.profileImage || '/images/icons/defaultUser.svg'}
										alt='img'
										className='brdrRadius50'
										delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
										effect={process.env.REACT_APP_EFFECT}
										width={`${process.env.REACT_APP_IMG_WIDTH}%`}
										height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
									/> */}
									<Box width={40} height={40} alignItems='center' justifyContent='center' display='flex'
										border='1px solid rgba(0, 0, 0, 0.12)'
										className='brdrRadius50'
									>
										<ProfilePic
											imagePath={item?.profileImage || '/images/icons/defaultUser.svg'}
											defaultImg='/images/icons/defaultUser.svg'
											loadUrl='profile'
											alt='createdBy_img'
											className='brdrRadius50'
										/>
									</Box>
								</div>
							</div>
							<div className='flexMinWidthCol pdngHSM'>
								<span className='titleHeading capitalTxt'>{item?.name}</span>
								<span className='lightTxt capitalTxt headingSM'>{item?.type}</span>

							</div>
						</div>
					))}
				</div>
			</div>

		</>
	);
};

export default SharedInfo;